import { EBaseIconVariant } from '@spinwise/react-component-library/BaseIcon';

// Custom to this brand icons
export enum EBrandIconVariants {
  Default = 'icon-variant--default',
  Default01 = 'icon-variant--default-01',
  Warning = 'icon-variant--warning',
  WarningCrypto = 'icon-variant--warning-crypto',
  Plain = 'icon-variant--plain',
  PlainDark = 'icon-variant--plain-dark',
  Alpha30 = 'icon-variant--alpha-30',
  Alpha50 = 'icon-variant--alpha-50',
  Epsilon = 'icon-variant--epsilon',
  Epsilon40 = 'icon-variant--epsilon-40',
  Black = 'icon-variant--black',
  Black01 = 'icon-variant--black-01',
  Black02 = 'icon-variant--black-02',
  Black03 = 'icon-variant--black-03',
  Black04 = 'icon-variant--black-04',
  Black05 = 'icon-variant--black-05',
  Black08 = 'icon-variant--black-08',
  Black09 = 'icon-variant--black-09',
  White = 'icon-variant--white',
  White02 = 'icon-variant--white-02',
  White05 = 'icon-variant--white-05',
  White06 = 'icon-variant--white-06',
  White08 = 'icon-variant--white-08',
  StatusSuccess = 'icon-variant--status-success',
  StatusProcessing = 'icon-variant--status-processing',
  StatusSuspended = 'icon-variant--status-suspended',
  StatusError = 'icon-variant--status-error',
  TableDot = 'icon-variant--table-dot',
  TopNav = 'icon-variant--top-nav',
  TopNavHover = 'icon-variant--top-nav-hover',
  HomepageNav = 'icon-variant--homepage-nav',
  SuperchargeBtn = 'icon-variant--supercharge-btn',
  SuperchargeBtnLocked = 'icon-variant--supercharge-btn-locked',
  FaqCross = 'icon-variant--faq-cross',
  Dots = 'icon-variant--dots',
  HeaderNav = 'icon-variant--header-nav',
  FavoriteActive = 'icon-variant--favorite-active',
  AccountNav = 'icon-variant--account-nav',
  AccountNavHover = 'icon-variant--account-nav-hover',
  AccountNavActive = 'icon-variant--account-nav-active',
  ValidationError = 'icon-variant--validation-error',
  Secondary = 'icon-variant--secondary',
  Purple = 'icon-variant--purple',
  PurpleDefault = 'icon-variant--purple-default',
  PurpleLock = 'icon-variant--purple-lock',
  Transparent = 'icon-variant--transparent',
  Disclaimer = 'icon-variant--disclaimer',
  Terms = 'icon-variant--terms',
  LockedPlus = 'icon-variant--locked-plus',
  LockedBtnIcon = 'icon-variant--locked-btn-icon',
  NavArrowActive = 'icon-variant--nav-arrow-active',
  NavArrowDisabled = 'icon-variant--nav-arrow-disabled',
  NavPrivderScroll = 'icon-variant--provider-scroll',
  DepositLock = 'icon-variant--deposit-lock',
  PromotionOffer = 'icon-variant--promotion-offer',
  Done = 'icon-variant--done',
  CurrentColor = 'icon-variant--current-color',
}

export type EVariants = EBrandIconVariants | EBaseIconVariant | string;

export const IconVariantsLibrary = {
  ...EBrandIconVariants,
  ...EBaseIconVariant,
};
